import { render, staticRenderFns } from "./AddSubParts.vue?vue&type=template&id=3c271f7c"
import script from "./AddSubParts.vue?vue&type=script&lang=js"
export * from "./AddSubParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports